import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames/bind';

import { useUserPermissionStatus } from 'selectors/user';
import type { SurfDataPoints } from 'types/surf';
import type { SurfHeight } from 'types/units';
import { useForecastDaysAllowed } from 'utils/forecastDaysAllowed';
import useSetupCurveGraph from '../../hooks/useSetupCurveGraph';

import styles from './DaySelectorGraph.module.scss';

const cx = classNames.bind(styles);
interface Props {
  data: SurfDataPoints;
  height: number;
  spotId: string;
  isPaywallVisible?: boolean;
  parentRef: any;
  units: SurfHeight;
  chartIdPrefix?: string;
}

// This is the 16-Day Selector at the top of the Spot Page
const DaySelectorGraph: React.FC<Props> = ({
  data,
  height = 0,
  spotId,
  isPaywallVisible,
  parentRef,
  units,
  chartIdPrefix,
}) => {
  const { hasCoreForecastPermissions } = useUserPermissionStatus();

  const { forecastDaysAllowed } = useForecastDaysAllowed({
    type: 'spot',
    isEntitled: hasCoreForecastPermissions,
  });

  const waveData = useMemo(
    () => data.slice(0, (data.length / 16) * forecastDaysAllowed),
    [forecastDaysAllowed, data],
  );

  const { setupCurveGraph } = useSetupCurveGraph({
    spotId,
    data: waveData,
    parentRef,
    height,
    units,
    chartIdPrefix,
  });

  useEffect(() => {
    setupCurveGraph();
  }, [height, setupCurveGraph]);

  return (
    <div className={cx(['day-selector-chart-wrapper', 'daySelectorChartWrapper'])}>
      <div
        className={cx([
          'day-selector-chart-content',
          'daySelectorChart',
          {
            'daySelectorChart--paywall': isPaywallVisible,
            'daySelectorChart--paywall-V3': isPaywallVisible,
          },
        ])}
      />
    </div>
  );
};

export default DaySelectorGraph;
